import styled, { css } from 'styled-components';

type Tone = 'success' | 'warning' | 'neutral';

const TONE_MAP: Record<Tone, { bg: string; color: string }> = {
  success: { bg: '#e6f3ec', color: '#006633' },
  warning: { bg: '#fff4e0', color: '#b45309' },
  neutral: { bg: '#f1f5f9', color: '#475569' },
};

export const StatusBadge = styled.span<{ $tone: Tone }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: -0.01em;
  ${({ $tone }) => css`
    background: ${TONE_MAP[$tone].bg};
    color: ${TONE_MAP[$tone].color};
  `}
`;

export const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  &:hover {
    background: #f8fafc;
    border-color: #006633;
    color: #006633;
  }
`;

export const BatchButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid transparent;
  background: #006633;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: #00451f;
  }
`;
